import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutRow, FlexLayoutCol } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { SliderLayout } from '../../../../vtex-apps/slider-layout/SliderLayout/default';
import { ProductSummaryList as ProductSummaryListComponent } from '../../../../vtex-apps/product-summary/ProductSummaryList/default';
import { TabLayout } from '../../../../vtex-apps/tab-layout/TabLayout/default';
import { TabListItem } from '../../../../vtex-apps/tab-layout/TabListItem/default';
import { TabList } from '../../../../vtex-apps/tab-layout/TabList/default';
import { TabContent } from '../../../../vtex-apps/tab-layout/TabContent/default';
import { TabContentItem } from '../../../../vtex-apps/tab-layout/TabContentItem/default';
import { Link } from '../../../../vtex-apps/Link/Link/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function ProductSummaryList() {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		componentGroup: 'ProductSummaryList',
		variables,
		props: VisibilityLayout({ mzTitle: 'MZ | Vitrine (On/Off)' }).props,
		childrenComponents: [
			FlexLayoutRow({ blockClass: 'shelf__product-list-1', mzTitle: 'MZ | Vitrine' }, [
				FlexLayoutCol({ blockClass: 'product-list__flex-col-1' }, [
					RichText({
						textAlignment: 'CENTER',
						textPosition: 'CENTER',
						text: '## Os mais vendidos',
						textColor: 'emphasis',
						font: 't-heading-5',
						blockClass: 'product-list__title-1',
					}),
					TabLayout({ blockClass: 'product-list__tab-layout-1' }, [
						TabList({ blockClass: 'product-list__tab-list-1' }, [
							TabListItem({
								blockClass: 'product-list__list-item-1',
								tabId: 'tab-1',
								label: 'label 1 nome grande',
							}),
							TabListItem({
								blockClass: 'product-list__list-item-1',
								tabId: 'tab-2',
								label: 'label 2 nome grandao pra ocupar espaço',
							}),
							TabListItem({
								blockClass: 'product-list__list-item-1',
								tabId: 'tab-3',
								label: 'label 3 scroll horizontal',
							}),
							TabListItem({
								blockClass: 'product-list__list-item-1',
								tabId: 'tab-4',
								label: 'label 4 scroll horizontal',
							}),
						]),
						TabContent({ blockClass: 'product-list__tab-content-1' }, [
							TabContentItem({ tabId: 'tab-1' }, [
								FlexLayoutRow(
									{
										blockClass: 'product-list__tab-row-1',
										colSizing: '100%',
										paddingBottom: { desktop: 7, tablet: 7, mobile: 6 },
									},
									[
										ProductSummaryListComponent(
											{ blockClass: 'summary__list-1' },
											[
												SliderLayout({
													blockClass: 'summary__slider-layout-1',
													itemsPerPage: {
														desktop: 4,
														tablet: 2,
														phone: 1,
													},
												}),
											],
											[
												{
													componentGroup: 'ProductSummaryShelf',
													componentName: 'ProductSummaryShelfComponent',
													componentId: uuidv4(),
												},
											],
										),
									],
								),
								FlexLayoutRow({ blockClass: 'summary-list__link-container', horizontalAlign: 'center' }, [
									Link({
										label: 'Ver mais produtos',
										displayMode: 'button',
										blockClass: 'product-list__see-more-link-1',
									}),
								]),
							]),
							TabContentItem({ tabId: 'tab-2' }, [
								FlexLayoutRow(
									{
										blockClass: 'product-list__tab-row-1',
										colSizing: '100%',
										paddingBottom: { desktop: 7, tablet: 7, mobile: 6 },
									},
									[
										ProductSummaryListComponent(
											{ blockClass: 'summary__list-1' },
											[
												SliderLayout({
													blockClass: 'summary__slider-layout-1',
													itemsPerPage: {
														desktop: 4,
														tablet: 2,
														phone: 1,
													},
												}),
											],
											[
												{
													componentGroup: 'ProductSummaryShelf',
													componentName: 'ProductSummaryShelfComponent',
													componentId: uuidv4(),
												},
											],
										),
									],
								),
							]),
							TabContentItem({ tabId: 'tab-3' }, [
								FlexLayoutRow(
									{
										blockClass: 'product-list__tab-row-1',
										colSizing: '100%',
										paddingBottom: { desktop: 7, tablet: 7, mobile: 6 },
									},
									[
										ProductSummaryListComponent(
											{ blockClass: 'summary__list-1' },
											[
												SliderLayout({
													blockClass: 'summary__slider-layout-1',
													itemsPerPage: {
														desktop: 4,
														tablet: 2,
														phone: 1,
													},
												}),
											],
											[
												{
													componentGroup: 'ProductSummaryShelf',
													componentName: 'ProductSummaryShelfComponent',
													componentId: uuidv4(),
												},
											],
										),
									],
								),
							]),
							TabContentItem({ tabId: 'tab-4' }, [
								FlexLayoutRow(
									{
										blockClass: 'product-list__tab-row-1',
										colSizing: '100%',
										paddingBottom: { desktop: 7, tablet: 7, mobile: 6 },
									},
									[
										ProductSummaryListComponent(
											{ blockClass: 'summary__list-1' },
											[
												SliderLayout({
													blockClass: 'summary__slider-layout-1',
													itemsPerPage: {
														desktop: 4,
														tablet: 2,
														phone: 1,
													},
												}),
											],
											[
												{
													componentGroup: 'ProductSummaryShelf',
													componentName: 'ProductSummaryShelfComponent',
													componentId: uuidv4(),
												},
											],
										),
									],
								),
							]),
						]),
					]),
				]),
			]),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--psl-1-background', name: 'Background' },
			{ from: '--brand-color-primary-pure', to: '--psl-1-slider-color', name: 'Slider' },
			{ from: '--white', to: '--psl-1-slider-arrow-color', name: 'Arrows' },
			{ from: '--brand-color-primary-pure', to: '--psl-1-slider-dots-color', name: 'dots' },
			{ from: '--brand-color-primary-pure', to: '--psl-1-tab-color', name: 'Tab' },
			{ from: '--brand-color-primary-pure', to: '--psl-1-heading-color', name: 'Heading' },
			{ from: '--white', to: '--psl-1-tab-text-color-active', name: 'Tab Text Active' },
			{ from: '--text-color-1', to: '--psl-1-tab-text-color', name: 'Tab Text' },
			{ from: '--white', to: '--psl-1-tab-background', name: 'Tab Background' },
			{ from: '--white', to: '--psl-1-tab-border', name: 'Tab Border' },
			{ from: '--cta-color-pure', to: '--psl-1-cta-background', name: 'CTA' },
			{ from: '--cta-color-hover', to: '--psl-1-cta-background-hover', name: 'CTA Hover' },
			{ from: '--cta-color-focus', to: '--psl-1-cta-background-focus', name: 'CTA Active' },
			{ from: '--white', to: '--psl-1-cta-color', name: 'CTA Text Color' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-sm', to: '--psl-1-tab-radius', name: 'Tab Top' },
			{ from: '--border-radius-none', to: '--psl-1-tab-radius-bottom', name: 'Tab Bottom' },
			{ from: '--border-radius-sm', to: '--psl-1-slider-radius', name: 'Slider' },
			{ from: '--border-radius-sm', to: '--psl-1-cta-radius', name: 'CTA' },
		],
	},
	{
		type: 'borderWidth',
		list: [
			{ from: '--border-width-hairline', to: '--psl-1-tab-item-b-width', name: 'Tab Item Width' },
			{ from: '--border-width-thin', to: '--psl-1-line-width', name: 'Line Width' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xxl', to: '--psl-1-heading-fontsize', name: 'Heading' },
			{ from: '--font-size-sm', to: '--psl-1-tab-fontsize', name: 'Tab' },
			{ from: '--font-size-sm', to: '--psl-1-cta-fs', name: 'CTA' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-700', to: '--psl-1-cta-fw', name: 'CTA' },
			{ from: '--font-weight-700', to: '--psl-1-heading-fw', name: 'Heading' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--psl-1-fontfamily', name: 'Font Family' },
			{ from: '--main-font', to: '--psl-1-cta-ff', name: 'CTA Font Family' },
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-xxs', to: '--psl-1-dot-width', name: 'Dot Width' },
			{ from: '--spacing-xxs', to: '--psl-1-dot-width-active', name: 'Dot Width Active' },
			{ from: '--spacing-nano', to: '--psl-1-dot-height', name: 'Dot Height' },
			{ from: '--spacing-nano', to: '--psl-1-dot-height-active', name: 'Dot Height Active' },
			{ from: '--spacing-md', to: '--psl-1-slider-btn', name: 'Slider Buttons' },
			{ from: '0', to: '--psl-1-tab-gap', name: 'Tab Gap' },
		],
	},
];
